/**
 * Internationalisation (i18n) helpers
 */
export const SUPPORTED_LOCALES = ['fi', 'en', 'sv'];

export const checkLocaleSupport = function (locale) {
    return SUPPORTED_LOCALES.indexOf(locale) > -1;
};

/**
 * Default locale is taken from `navigator.language`.
 */
export const getDefaultLocale = function () {
    const locale = typeof navigator !== 'undefined' ? navigator.language.substring(0, 2) : 'en';
    if (!checkLocaleSupport(locale)) {
        console.warn(`Locale "${locale}" is not supported`);
        return 'en'; // English is the default
    }
    return locale;
};

/**
 * Load translation strings for vue-i18n.
 * DEPRECATED; messages are load async.
 */
export const getMessages = function (locales) {
    const messages = {};
    // SUPPORTED_LOCALES.forEach((lang) => {
    //     messages[lang] = require(`@/translations/locale-${lang}.json`);
    // });
    return messages;
};

export const loadedLanguages = [];

// import { loadMessages as dxLoadMessages } from 'devextreme/localization'; // attached to window.dxLoadMessages

/**
 * Load translation files asynchronously
 */
export const getMessagesAsync = async function (i18n, locale) {

    // load if this locale has not yet been loaded
    if (!loadedLanguages.includes(locale)) {

        const main = await import(/* webpackChunkName: "[request]" */`@/translations/locale-${locale}.json`)
            .then((messages) => {
                i18n.setLocaleMessage(locale, messages.default);
                return true;
            })
            .catch((error) => { throw error; });

        // FIXME: DX i18n needs to merge upstream messages with dx-html-editor translation patches in plugins/dev-extreme.
        //        currently it is better not to load these messages, only the patches.
        // let dx;
        // if (window.dxLoadMessages) {
        //     dx = await import(/* webpackChunkName: "dx-locale-[request]" */`devextreme/localization/messages/${locale}.json`)
        //         .then((messages) => {
        //             window.dxLoadMessages(messages.default);
        //             return true;
        //         })
        //         .catch((error) => { throw error; });
        // }

        // resolve as loaded if both promises resolved
        main && loadedLanguages.push(locale);
    }

    return Promise.resolve(locale);
};
